(() => {
  window.UrbanGiftingStorage = {
    decodeCatalog(record) {
      const head = record?.workspace;
      if (head == null) return null;
      let value = head;
      if (head.storage) {
        if (head.storage !== 'gifting-workspace-chunks-v1' || !/^[a-zA-Z0-9-]{1,64}$/.test(head.revision || '') ||
          !Array.isArray(head.keys) || !head.keys.length || head.keys.length > 24 ||
          head.keys.some((key, index) => key !== `data_part_${index + 1}`)) throw new Error('Invalid catalog revision');
        const source = head.keys.map((_, index) => {
          const part = record[`part${index + 1}`];
          if (part?.revision !== head.revision || typeof part.payload !== 'string') throw new Error('Incomplete catalog revision');
          return part.payload;
        }).join('');
        value = JSON.parse(source);
      }
      if (value?.schema !== 1 || value.storage || !Array.isArray(value.campaigns)) throw new Error('Invalid catalog');
      return value.campaigns;
    }
  };
})();

